import { createContext, FC, PropsWithChildren, useContext, useState } from "react";

export type AppLanguageType = "en" | "fr" | "de" | "es";

type ContextProps = {
  offline: {
    isOffline: boolean;
    setIsOffline: React.Dispatch<React.SetStateAction<boolean>>;
  };
};

const Context = createContext<ContextProps>({
  offline: {
    isOffline: false,
    setIsOffline: () => null,
  },
});

export const useStorage: () => ContextProps = () => useContext(Context);

export const StorageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOffline, setIsOffline] = useState(false);

  const context: ContextProps = {
    offline: {
      isOffline,
      setIsOffline,
    },
  };

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
